module.exports = __webpack_public_path__ + "images/edit1c84c067fef9eaee98e7c70e82733674.svg";